import React from 'react';

import { IStyledLink, LinkStyled, LinkStyledSimple } from './styled';
import ArrowLinkIcon from 'assets/svg/link-arrow.svg';
import { SmallText, Text } from 'ds/components/typography';
import useAnchorLink from 'hooks/useAnchorLink';

interface ILink extends React.AnchorHTMLAttributes<HTMLAnchorElement | HTMLDivElement>, IStyledLink { }

export const Link: React.FunctionComponent<ILink> = ({ small, simple, target, ...props }) => {
  const Comp = simple ? LinkStyledSimple : LinkStyled;
  const TextComponent = small ? SmallText : Text;
  const href = useAnchorLink(props.href);
  const nextProps = { ...props, href, target };
  return (
    <TextComponent>
      <Comp small={small} {...nextProps}>
        {props.children} {props.withArrow ? <ArrowLinkIcon /> : null}
      </Comp>
    </TextComponent>
  );
};

